import { motion } from "framer-motion";
import { MapPin, Briefcase, Building2 } from "lucide-react";
import { experience } from "@/data/portfolio";
import { Section } from "@/components/Section";

const Role = ({ role, i }) => (
  <motion.article
    data-testid={`experience-role-${i}`}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.6, delay: i * 0.05 }}
    className={`group grid gap-6 border-t border-white/10 py-10 transition-colors duration-500 hover:bg-white/[0.02] lg:grid-cols-[220px_1.1fr_1.6fr] lg:gap-10 lg:py-12 ${
      role.current ? "border-l-2 border-l-cyan-400 pl-6" : ""
    }`}
  >
    <div className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">
      <span className="text-cyan-400">{String(i + 1).padStart(2, "0")}</span>
      <span className="mx-2 text-zinc-700">/</span>
      <span className="text-zinc-300">{role.dates}</span>
      {role.current && (
        <span className="mt-3 inline-block border border-cyan-400/50 px-2 py-1 text-[10px] text-cyan-400">
          CURRENT
        </span>
      )}
    </div>
    <div>
      <h3 className="font-display text-xl font-bold text-white transition-colors duration-300 group-hover:text-cyan-400 md:text-2xl">
        {role.title}
      </h3>
      <p className="mt-2 flex items-center gap-2 font-mono text-sm text-zinc-400">
        <Building2 className="h-3.5 w-3.5 text-cyan-400/70" /> {role.company}
      </p>
      <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1 font-mono text-[11px] uppercase tracking-wider text-zinc-500">
        <span className="flex items-center gap-1.5">
          <Briefcase className="h-3 w-3" /> {role.type}
        </span>
        {role.location && (
          <span className="flex items-center gap-1.5">
            <MapPin className="h-3 w-3" /> {role.location}
          </span>
        )}
        {role.workplace && <span>{role.workplace}</span>}
      </div>
    </div>
    <ul className="space-y-2.5 text-sm leading-relaxed text-zinc-400">
      {role.bullets.map((b, j) => (
        <li key={j} className="flex gap-3">
          <span className="mt-2 h-px w-4 shrink-0 bg-cyan-400/50" />
          {b}
        </li>
      ))}
    </ul>
  </motion.article>
);

export const Experience = () => (
  <Section id="experience" index="01" title="Experience">
    <div data-testid="experience-timeline" className="border-b border-white/10">
      {experience.map((role, i) => (
        <Role key={`${role.company}-${role.dates}`} role={role} i={i} />
      ))}
    </div>
  </Section>
);
